// ============================================================================
// ARABIC TRANSLATIONS - CHAPTER 3: يسوع المسيح
// ============================================================================
// المستويات 27-39 (13 مستوى، 39 سؤالاً)

export const chapter3Translations = {
  name: 'يسوع المسيح',
  description: 'الكلمة صار جسداً... معرفة المسيح هي الحياة الأبدية',
  
  spiritualWisdom: {
    principle: 'معرفة يسوع المسيح هي الحياة الأبدية',
    scripture: 'وهذه هي الحياة الأبدية: أن يعرفوك أنت الإله الحقيقي وحدك ويسوع المسيح الذي أرسلته (يوحنا 17:3)',
    application: 'كل جانب من حياة يسوع يكشف الله ويغذي روحنا للأبدية'
  },
  
  levels: {
    27: {
      name: 'البشارة',
      challenge: 'أرسل الملاك جبرائيل من الله إلى مدينة في الجليل...',
      easy: {
        question: 'أي ملاك بشر مريم بأنها ستحمل يسوع؟',
        options: ['ميخائيل', 'جبرائيل', 'رافائيل', 'أوريئيل'],
        hint: 'ملاك رسول الله',
        funFact: '👼 جبرائيل يعني قوة الله - ملاك البشارات العظيمة!'
      },
      medium: {
        question: 'ما كانت ردة فعل مريم الأولى على هذه البشارة؟',
        options: [
          'الفرح الفوري',
          'عدم التصديق الكامل',
          'الاضطراب والسؤال كيف يكون هذا؟',
          'الخوف'
        ],
        hint: 'سؤال عملي ومشروع',
        funFact: '🤔 مريم تطرح سؤالاً منطقياً لكنها تبقي قلباً منفتحاً على الله!'
      },
      hard: {
        question: 'ماذا يعلمنا خضوع مريم للإرادة الإلهية؟',
        options: [
          'السلبية أمام المحن',
          'الإيمان الذي يثق حتى دون فهم كل شيء',
          'الطاعة العمياء',
          'الاستسلام'
        ],
        hint: 'الأمر يتعلق بالثقة بالله حتى في المجهول',
        funFact: '🙏 ليكن لي بحسب قولك - نموذج الإيمان الواثق!'
      }
    },
    
    28: {
      name: 'الميلاد',
      challenge: 'ولدت ابنها البكر وقمطته وأضجعته في المذود...',
      easy: {
        question: 'في أي مدينة ولد يسوع؟',
        options: ['الناصرة', 'أورشليم', 'بيت لحم', 'كفرناحوم'],
        hint: 'مدينة داود',
        funFact: '🏘️ بيت لحم تعني بيت الخبز - يسوع خبز الحياة!'
      },
      medium: {
        question: 'من كانوا أول من تلقوا بشارة الميلاد؟',
        options: [
          'المجوس',
          'الرعاة في الحقول',
          'كهنة الهيكل',
          'عائلة مريم'
        ],
        hint: 'ناس بسطاء كانوا يحرسون قطعانهم',
        funFact: '🐑 الله يبشر أولاً الرعاة المتواضعين - الإنجيل للجميع!'
      },
      hard: {
        question: 'ماذا يرمز ميلاد يسوع في المذود؟',
        options: [
          'فقر والديه',
          'تواضع الله الذي ينحني حتى إلينا',
          'نقص المكان',
          'البساطة الريفية'
        ],
        hint: 'الأمر يتعلق بالتجسد الإلهي في التواضع',
        funFact: '👶 خالق الكون يولد في مذود - محبة لا نهائية!'
      }
    },

    29: {
      name: 'المجوس من المشرق',
      challenge: 'مجوس من المشرق جاءوا إلى أورشليم وسألوا...',
      easy: {
        question: 'ما الذي أرشد المجوس إلى يسوع؟',
        options: ['ملاك', 'نجم', 'رؤيا', 'خريطة'],
        hint: 'نجم في السماء',
        funFact: '⭐ النجم يمثل أن يسوع هو نور الأمم!'
      },
      medium: {
        question: 'ما الهدايا التي قدمها المجوس؟',
        options: [
          'طعام',
          'ذهب ولبان ومر',
          'ملابس ثمينة',
          'ألعاب'
        ],
        hint: 'ثلاث هدايا رمزية وثمينة',
        funFact: '🎁 الذهب (الملكية)، اللبان (الألوهية)، المر (الذبيحة) - كل مهمة يسوع!'
      },
      hard: {
        question: 'ماذا يمثل هؤلاء المجوس الوثنيون في خطة الله؟',
        options: [
          'تفوق الديانات الأخرى',
          'عالمية الخلاص المقدم لجميع الشعوب',
          'الثروة المادية',
          'العلم القديم'
        ],
        hint: 'الأمر يتعلق بانفتاح الخلاص على جميع الأمم',
        funFact: '🌍 المجوس يسبقون الإنجيل الذي سيصل العالم كله!'
      }
    },

    30: {
      name: 'معمودية يسوع',
      challenge: 'فلما اعتمد يسوع صعد للوقت من الماء...',
      easy: {
        question: 'من عمد يسوع؟',
        options: ['بطرس', 'يوحنا المعمدان', 'أندراوس', 'يعقوب'],
        hint: 'سابق يسوع',
        funFact: '🌊 يوحنا المعمدان كان يعتبر نفسه غير مستحق لحل سيور حذاء يسوع!'
      },
      medium: {
        question: 'ماذا نزل على يسوع عند معموديته؟',
        options: [
          'نور',
          'حمامة (الروح القدس)',
          'ملاك',
          'صوت فقط'
        ],
        hint: 'الطائر رمز السلام',
        funFact: '🕊️ الحمامة تكشف المسحة الإلهية لبدء الخدمة!'
      },
      hard: {
        question: 'لماذا اعتمد يسوع الخالي من الخطية؟',
        options: [
          'ليعطي المثال',
          'ليتمم كل بر ويتماهى معنا',
          'بسبب الالتزام الديني',
          'ليتلقى المغفرة'
        ],
        hint: 'الأمر يتعلق بالتضامن مع البشرية الخاطئة',
        funFact: '❤️ يسوع يتماهى تماماً معنا لينقذنا بشكل أفضل!'
      }
    },

    31: {
      name: 'التجربة في البرية',
      challenge: 'قاد الروح يسوع إلى البرية ليجرب من إبليس...',
      easy: {
        question: 'كم يوماً صام يسوع في البرية؟',
        options: ['30 يوماً', '40 يوماً', '50 يوماً', '60 يوماً'],
        hint: 'الرقم الكتابي للمحنة',
        funFact: '🏜️ مثل موسى وإيليا، 40 يوماً من الإعداد الروحي المكثف!'
      },
      medium: {
        question: 'كيف رد يسوع على كل تجربة؟',
        options: [
          'بقوته الخاصة',
          'باقتباس الكتب المقدسة',
          'بتجاهل الشيطان',
          'بالصلاة فقط'
        ],
        hint: 'السلاح الروحي بامتياز',
        funFact: '📖 مكتوب... - كلمة الله، سيف الروح!'
      },
      hard: {
        question: 'ماذا تعلمنا تجربة يسوع عن معاركنا؟',
        options: [
          'التجارب خطيئة',
          'يمكن التغلب على التجربة بالكلمة والإيمان',
          'يجب الهروب من كل برية',
          'يسوع وحده يمكنه المقاومة'
        ],
        hint: 'الأمر يتعلق باستراتيجيتنا أمام التجارب',
        funFact: '⚔️ يسوع يظهر لنا كيف ننتصر: كلمة الله + إيمان فعال!'
      }
    },

    32: {
      name: 'التلاميذ الأوائل',
      challenge: 'قال لهم يسوع: هلم ورائي فأجعلكما صيادي الناس...',
      easy: {
        question: 'ما كانت مهنة بطرس وأندراوس؟',
        options: ['رعاة', 'صيادون', 'نجارون', 'جباة ضرائب'],
        hint: 'مهنة من بحيرة الجليل',
        funFact: '🎣 يسوع يحول صيادي السمك إلى صيادي النفوس!'
      },
      medium: {
        question: 'كيف تفاعل التلاميذ الأوائل مع الدعوة؟',
        options: [
          'ترددوا طويلاً',
          'طلبوا أدلة',
          'تركوا كل شيء وتبعوه فوراً',
          'تفاوضوا'
        ],
        hint: 'استجابة فورية وكاملة',
        funFact: '🚶 سلطة يسوع كانت واضحة جداً لدرجة أنهم أطاعوا فوراً!'
      },
      hard: {
        question: 'ماذا يعني اتباع يسوع في عصرنا؟',
        options: [
          'التخلي عن العمل',
          'العيش وفقاً لتعاليمه وإرادته',
          'الانضمام إلى مجتمع معزول',
          'التبشير فقط'
        ],
        hint: 'الأمر يتعلق بتحول الحياة والأولويات',
        funFact: '✨ اتباع يسوع يحول قلوبنا، خياراتنا، مصيرنا!'
      }
    },

    33: {
      name: 'الموعظة على الجبل',
      challenge: 'طوبى للمساكين بالروح، لأن لهم ملكوت السماوات...',
      easy: {
        question: 'ما هي أول بركة (طوبى) في الموعظة على الجبل؟',
        options: [
          'طوبى للأنقياء القلب',
          'طوبى للمساكين بالروح',
          'طوبى للودعاء',
          'طوبى لصانعي السلام'
        ],
        hint: 'تتعلق بالتواضع الروحي',
        funFact: '😊 المساكين بالروح يعرفون حاجتهم لله - باب الملكوت!'
      },
      medium: {
        question: 'ماذا قال يسوع عن صانعي السلام؟',
        options: [
          'سيكونون محظوظين',
          'سيُدعون أبناء الله',
          'سيكونون محبوبين',
          'سيكونون أقوياء'
        ],
        hint: 'هوية إلهية خاصة',
        funFact: '👑 صانعو السلام يشبهون الله - شهادة حية لطبيعته!'
      },
      hard: {
        question: 'كيف تقلب التطويبات قيم العالم؟',
        options: [
          'بإدانة الغنى',
          'بعزل المؤمنين',
          'بإعلان مباركة من يحتقرهم العالم',
          'بإلغاء القوانين'
        ],
        hint: 'يتعلق بقيم إلهية معاكسة للقيم الدنيوية',
        funFact: '🔄 التطويبات تحول رؤيتنا للسعادة والنجاح!'
      }
    },

    34: {
      name: 'أمثال الملكوت',
      challenge: 'وعلّمهم كثيراً بأمثال...',
      easy: {
        question: 'في مثل الزارع، ماذا يمثل الزرع؟',
        options: [
          'المال',
          'كلمة الله',
          'الأعمال الصالحة',
          'المحبة'
        ],
        hint: 'ما يعلنه ويعلّمه يسوع',
        funFact: '🌱 كلمة الله تنبت وتنمو في قلوبنا!'
      },
      medium: {
        question: 'في مثل حبة الخردل، ماذا ترمز هذه البذرة الصغيرة؟',
        options: [
          'الضعف البشري',
          'الملكوت الذي يبدأ صغيراً لكنه يصير عظيماً',
          'أهمية التفاصيل',
          'الطبيعة'
        ],
        hint: 'شيء ينمو بشكل مذهل',
        funFact: '🌳 من أصغر بذرة تولد شجرة عظيمة - قوة الملكوت!'
      },
      hard: {
        question: 'لماذا كان يسوع يعلّم بأمثال؟',
        options: [
          'لتعقيد رسالته',
          'لإعلان الحقائق الروحية بصور مألوفة',
          'بسبب قلة الوقت',
          'لاختبار الذكاء'
        ],
        hint: 'يتعلق بجعل أسرار الملكوت في متناول الجميع',
        funFact: '💡 الأمثال تكشف للقلوب المنفتحة وتحجب عن القلوب المغلقة!'
      }
    },

    35: {
      name: 'معجزات يسوع',
      challenge: 'فسكّت الريح وقال للبحر: اسكت! ابكم!...',
      easy: {
        question: 'بكم رغيف أشبع يسوع 5000 رجل؟',
        options: ['3 أرغفة', '5 أرغفة', '7 أرغفة', '12 رغيفاً'],
        hint: 'نفس عدد السمكات',
        funFact: '🍞 5 أرغفة وسمكتان تصيران وليمة - كرم إلهي!'
      },
      medium: {
        question: 'ماذا قال التلاميذ عندما سكّن يسوع العاصفة؟',
        options: [
          'إنه ساحر',
          'من هو هذا الذي يطيعه الريح والبحر؟',
          'هذا طبيعي',
          'يجب أن نغادر من هنا'
        ],
        hint: 'سؤال عن هوية يسوع',
        funFact: '⛈️ حتى العناصر تعترف بخالقها وسيدها!'
      },
      hard: {
        question: 'ما هو الهدف الرئيسي من معجزات يسوع؟',
        options: [
          'إبهار الجموع',
          'إعلان ألوهيته وإظهار محبة الله',
          'كسب النفوذ',
          'المساعدة المادية فقط'
        ],
        hint: 'يتعلق بإعلان إلهي ورحمة',
        funFact: '❤️ كل معجزة تكشف قلب الله: محبة، رحمة، قوة!'
      }
    },

    36: {
      name: 'التجلي',
      challenge: 'وتجلى قدامهم، وأضاء وجهه كالشمس...',
      easy: {
        question: 'أي تلاميذ رأوا يسوع متجلياً؟',
        options: [
          'الاثنا عشر جميعاً',
          'بطرس ويعقوب ويوحنا',
          'بطرس ويوحنا فقط',
          'النساء اللواتي تبعنه'
        ],
        hint: 'الدائرة الحميمة للثلاثة',
        funFact: '⛰️ بطرس ويعقوب ويوحنا: شهود مميزون للمجد الإلهي!'
      },
      medium: {
        question: 'أي شخصيات من العهد القديم ظهرت؟',
        options: [
          'إبراهيم وإسحاق',
          'داود وسليمان',
          'موسى وإيليا',
          'آدم ونوح'
        ],
        hint: 'ممثل الناموس وممثل الأنبياء',
        funFact: '📜 موسى (الناموس) وإيليا (الأنبياء) يشهدان ليسوع!'
      },
      hard: {
        question: 'ماذا يكشف هذا التجلي عن طبيعة يسوع؟',
        options: [
          'إنه نبي عظيم',
          'ألوهيته المحتجبة تظهر مؤقتاً',
          'يسيطر على النور',
          'يستطيع تغيير مظهره'
        ],
        hint: 'يتعلق بإعلان طبيعته الإلهية',
        funFact: '✨ المجد الإلهي ليسوع يشع - لمحة من قيامته!'
      }
    },

    37: {
      name: 'الدخول الانتصاري',
      challenge: 'أوصنا لابن داود! مبارك الآتي باسم الرب!...',
      easy: {
        question: 'على أي حيوان دخل يسوع إلى أورشليم؟',
        options: ['حصان', 'حمار', 'جمل', 'مشياً على الأقدام'],
        hint: 'حيوان رمز التواضع والسلام',
        funFact: '🐴 الحمار يرمز للملك المتواضع الآتي بسلام، لا بحرب!'
      },
      medium: {
        question: 'بماذا هتف الجمع مهللاً ليسوع؟',
        options: [
          'يحيا الملك!',
          'أوصنا! مبارك الآتي باسم الرب!',
          'المجد لله!',
          'الحرية!'
        ],
        hint: 'صرخة فرح وبركة',
        funFact: '🌿 "أوصنا" تعني "خلّص الآن" - دعوة للخلاص الإلهي!'
      },
      hard: {
        question: 'لماذا هذا الدخول "انتصاري" لكنه مأساوي؟',
        options: [
          'كان هناك عدد قليل من الناس',
          'الجمع الذي يهلل له سيرفضه بعد 5 أيام',
          'السلطات كانت غائبة',
          'كانت تمطر'
        ],
        hint: 'يتعلق بتقلب القلب البشري',
        funFact: '💔 نفس الجمع سيصرخ "اصلبه!" بعد أيام قليلة!'
      }
    },

    38: {
      name: 'العشاء الأخير',
      challenge: 'خذوا كلوا، هذا هو جسدي الذي يُبذل لأجلكم...',
      easy: {
        question: 'ماذا فعل يسوع بأقدام تلاميذه؟',
        options: [
          'باركها',
          'غسلها',
          'عطّرها',
          'قبّلها'
        ],
        hint: 'فعل تواضع وخدمة',
        funFact: '🦶 المعلم يصير خادماً - ثورة محبة وتواضع!'
      },
      medium: {
        question: 'ما الذي أسسه يسوع في هذه الوليمة؟',
        options: [
          'المعمودية',
          'المناولة (العشاء الرباني)',
          'صلاة الأبانا',
          'الصوم'
        ],
        hint: 'سر مع الخبز والخمر',
        funFact: '🍞🍷 الخبز والخمر يصيران رموزاً أبدية للذبيحة والمحبة!'
      },
      hard: {
        question: 'ماذا يعني "اصنعوا هذا لذكري"؟',
        options: [
          'كرروا هذه الوليمة',
          'احتفلوا بموتي وقيامتي حتى رجوعي',
          'تذكروا كلماتي',
          'أحبوا بعضكم بعضاً'
        ],
        hint: 'يتعلق بإحياء ذكرى حية ونبوية',
        funFact: '⏳ كل مناولة تبشر بموت الرب حتى مجيئه!'
      }
    },

    39: {
      name: 'جثسيماني',
      challenge: 'يا أبتاه، إن أمكن فلتعبر عني هذه الكأس...',
      easy: {
        question: 'أين صلى يسوع قبل القبض عليه؟',
        options: [
          'في الهيكل',
          'في بستان جثسيماني',
          'على جبل الزيتون',
          'عند أصدقائه'
        ],
        hint: 'بستان بأشجار الزيتون',
        funFact: '🫒 جثسيماني تعني "معصرة الزيت" - مكان ضغط مكثف!'
      },
      medium: {
        question: 'ماذا فعل التلاميذ بينما كان يسوع يصلي؟',
        options: [
          'صلّوا معه',
          'ناموا',
          'حرسوا',
          'غادروا'
        ],
        hint: 'لم يستطيعوا السهر ساعة واحدة',
        funFact: '😴 الروح نشيطة لكن الجسد ضعيف - الضعف البشري!'
      },
      hard: {
        question: 'ماذا تكشف نزاع يسوع عن طبيعته؟',
        options: [
          'كان إنساناً فقط',
          'كان إنساناً كاملاً وإلهاً كاملاً',
          'شك في رسالته',
          'كان ضعيفاً'
        ],
        hint: 'يتعلق بسر التجسد',
        funFact: '✝️ يسوع يتحمل القلق البشري بالكامل بينما يبقى أميناً لله!'
      }
    }
  }
};

export default chapter3Translations;
